import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-etiquetas',
  templateUrl: './etiquetas.component.html',
  styleUrls: ['./etiquetas.component.scss']
})
export class EtiquetasComponent implements OnInit {

  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  utils: any;
  constructor() {
    this.utils = window.utils;

    this.arrayComponent = [
      {
        id: 'tag-positive',
        claseContainer: 'col-6',
        componentRender:
        `
        <div class="tag-govco tag-positive">
          <span class="label">Etiqueta</span><span class="govco-icon govco-icon-x-cn size-2x tag-remove" aria-label="Close"></span>
        </div>
          `,
        titulo: 'Etiqueta - positiva',
        subtitulo: 'Permite implementar estiquetas en el estilo positivo (blanco y azul) definido en el Kit UI'
      },
      {
        id: 'tag-negative',
        claseContainer: 'col-6',
        componentRender:
        `
        <div class="tag-govco tag-negative">
          <span class="label">Etiqueta</span><span class="govco-icon govco-icon-x-cn size-2x tag-remove" aria-label="Close"></span>
        </div>
          `,
        titulo: 'Etiqueta - negativa',
        subtitulo: 'Permite implementar estiquetas en el estilo positivo (azul claro y oscuro) definido en el Kit UI'
      },
    ];

    this.infoComponent = {
      titulo: 'Etiquetas (tags)',
      descripcion: 'Las etiquetas son piezas de meta data que proveen acceso a categorías específicas del contenido así que apoyan la navegación con clasificación adicional de contenido:'
    }
  }

  ngOnInit() {
    this.utils.init();
  }

  ngAfterViewInit() {
    this.utils.removeTag();
  }
}  